import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import Box from '../Box';
import Card from '../Card';
import Checkbox from '../Checkbox';
import Text from '../Text';

function CheckboxCard(_ref) {
  var checked = _ref.checked,
      _onChange = _ref.onChange,
      subtitle = _ref.subtitle,
      title = _ref.title,
      restProps = _objectWithoutPropertiesLoose(_ref, ["checked", "onChange", "subtitle", "title"]);

  var _useState = useState(false),
      localChecked = _useState[0],
      setLocalChecked = _useState[1];

  var isActive = checked === undefined ? localChecked : checked;
  return /*#__PURE__*/React.createElement(Card, _extends({
    as: "label",
    axis: "horizontal",
    alignment: "center",
    width: "auto",
    padding: 1,
    spacing: 1,
    cursor: "pointer",
    borderColor: isActive ? 'separatorFocus' : 'separatorSecondary',
    hover: {
      borderColor: !isActive ? 'separator' : undefined
    },
    css: {
      ':focus-within': {
        stroke: 'separatorFocusSecondary',
        strokeWeight: 2
      }
    }
  }, restProps), /*#__PURE__*/React.createElement(Checkbox, {
    size: "sm",
    checked: checked,
    onChange: function onChange(event) {
      setLocalChecked(event.target.checked);
      _onChange && _onChange(event);
    }
  }), /*#__PURE__*/React.createElement(Box, {
    shrink: 1
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    title: title,
    truncate: true
  }, title), /*#__PURE__*/React.createElement(Text, {
    as: "span",
    title: subtitle,
    color: "foregroundSecondary",
    truncate: true
  }, subtitle)));
}

export default CheckboxCard;